import { render, staticRenderFns } from "./EffectiveDate.vue?vue&type=template&id=1908a804&scoped=true&"
import script from "./EffectiveDate.vue?vue&type=script&lang=js&"
export * from "./EffectiveDate.vue?vue&type=script&lang=js&"
import style0 from "./EffectiveDate.vue?vue&type=style&index=0&id=1908a804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908a804",
  null
  
)

component.options.__file = "EffectiveDate.vue"
export default component.exports